import { CloseIcon } from './mailRuleIcons';

/**
 * 輸入框右側的 ✕（AGUI-1284）：框裡有字才出現，按下清空並把游標留在框裡，圖示與「清除重要性」的 ✕ 相同。
 *
 * 按下時不讓輸入框失焦（preventDefault）：寄件者、關鍵字輸入列在失焦時會補加框內的字，
 * 不擋的話按 ✕ 會先把要清掉的字加進清單。
 * 不放進 Tab 順序：鍵盤使用者在框內就能刪字，多一站只會拖慢「輸入框 → 加入」的切換。
 *
 * @param {string} label 清的是哪一格，組成 aria-label「清除{label}」
 * @param {string} value 框內目前的字，空白時不顯示 ✕
 * @param {() => void} onClear
 * @param {{ current: HTMLInputElement|HTMLTextAreaElement|null }} inputRef 清完把游標放回去
 * @param {boolean} [multiline] 包的是 textarea：✕ 放在右上角，不垂直置中
 */
export default function MailRuleClearInput({ label, value, onClear, inputRef, multiline = false, children }) {
  return (
    <span className={`mail-rule-form__input-wrap${multiline ? ' mail-rule-form__input-wrap--multiline' : ''}`}>
      {children}
      {value && (
        <button type="button" className="mail-rule-form__input-clear" aria-label={`清除${label}`} title="清除"
          tabIndex={-1}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => {
            onClear();
            inputRef.current?.focus();
          }}>
          <CloseIcon size={16} />
        </button>
      )}
    </span>
  );
}
